import React, { ChangeEvent, Fragment} from "react";
import { Typography, AppBar, Toolbar, withStyles, Theme, createStyles, Card, CardHeader, CardContent, Button, MenuItem, FormControl, InputLabel, Select } from "@material-ui/core";
import {BrowserRouter as Router, Switch, Link, Route} from 'react-router-dom';
import EventsList from './EventsList';
import SignIn from './SignIn';
import Signup from "./Signup";
import {  withTranslation} from 'react-i18next';
import i18next from 'i18next';
import EventPage from './EventPage';
import MyEvents from "./MyEvents";

class StartPage extends React.Component<any, any>
{
    t : any;
    constructor(props: any) {
        super(props);
    }
    componentDidMount() {
        let {t} = this.props;
        document.title=t("TITLE");
    }
    setLanguage = (lang: string) => () => {
        i18next.changeLanguage(lang);
    }

    render() {
        //const { t, i18n } = useTranslation();
        let langs = [['se','Svenska'],['no','Norsk'],['fi','Suomeksi'],['en','English']];
        let langChoosers = [] as any[];
        langs.forEach((lang) => {
            if (i18next.language != lang[0])
            {
                if (langChoosers.length > 0)
                {
                    langChoosers.push(" | ");
                }
                langChoosers.push(<a href="#" onClick={this.setLanguage(lang[0])}><img src={"/images/" + lang[0] + ".png"}/> <span>{lang[1]}</span></a>);
            }
        })

        const { classes,t,i18n} = this.props;

        return <Router>
            <AppBar color="primary"
                position="static"
            >
                <Toolbar>
                    <Typography variant="h4" className={classes.title}>
                    <span style={{verticalAlign: 'middle'}}><Link style={{color:'white', textDecoration:'none'}} to="/">{t('TITLE')}</Link></span>
                   
                    
      </Typography>
                    
                    <div style={{textAlign:'right'}}>
                        
                            powered by: <img height="30" src="/images/logo_transparent.png" />
                            <div className="langChooser" >{langChoosers}</div></div>
                    
                </Toolbar>
                
            </AppBar>
            <Switch>
          
                <Route path="/signup">
                    <Signup/>
                </Route>
                <Route path="/events/:id">
                    <div id="mainFlex">
                            <div style={{flex:3}}>
                                <EventPage/>
                            </div>
                            <div className="flexCol2" style={{flex:1, margin: '2px', height: '100%'}}>
                                <Card>
                                <CardHeader className={classes.cardHeader} style={{color:'#FFF', padding: '3px'}} title={t('MANAGE_COURSES')}/>
                                    <CardContent>
                                        <SignIn/>
                                    </CardContent>
                                </Card>
                            </div>
                            </div>
                </Route>
                <Route path="/myEvents">
                    <div id="mainFlex">
                             <Card style={{flex:3, margin: '2px'}}>
                            <CardHeader className={classes.cardHeader} style={{color:'#FFF', padding: '3px'}} title={t('MY_COURSES')}/>
                                <MyEvents/>
                                </Card>
                            <div className="flexCol2" style={{flex:1, margin: '2px', height: '100%'}}>
                                <Card>
                                <CardHeader className={classes.cardHeader} style={{color:'#FFF', padding: '3px'}} title={t('MANAGE_COURSES')}/>
                                    <CardContent>
                                        <SignIn/>
                                    </CardContent>
                                </Card>
                            </div>
                            </div>
                </Route>
                <Route path="/">
                    <div id="mainFlex">
                        <Card style={{flex:3, margin: '2px'}}>
                            <CardHeader className={classes.cardHeader} style={{color:'#FFF', padding: '3px'}} title={t('AVAILABLE_COURSES')}/>
                            <EventsList/>
                            </Card>
                            <div className="flexCol2" style={{flex:1, margin: '2px', height: '100%'}}>
                                <Card>
                                <CardHeader className={classes.cardHeader} style={{color:'#FFF', padding: '3px'}} title={t('MANAGE_COURSES')}/>
                                    <CardContent>
                                        <SignIn/>
                                    </CardContent>
                                </Card>
                            </div>
                            </div>
                 </Route>
                
            </Switch>
              <div className="infoBox">
                        <Card style={{flex:3, margin: '5px 0'}}>
                        <CardHeader className={classes.cardHeader} style={{color:'#FFF', padding: '3px'}} title={t('ABOUT_SERVICE_HEADER')}/>
                        <CardContent>
                            <div style={{whiteSpace:'pre-wrap'}}>
                            {t('ABOUT_SERVICE_TEXT')}
                            </div>
                            </CardContent>
                        </Card>
                        <div style={{flex: 1}}></div>
                </div>
        </Router>;
    };
}



const useStyles = ({ palette, spacing }: Theme) => createStyles({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: spacing()
    },
    title: {
        flexGrow: 1,
    },
    cardHeader: {
        backgroundColor: palette.primary.main
    },
    
});


export default  withStyles(useStyles)(withTranslation()(StartPage));